import {currencyTranslations} from "./currency";

export const enTranslations = {
    common: {
        error: {
            required_field: "Required field",
            invalid_email: "Email address is invalid",
            invalid_email_with_address: "'{{email}}' is not valid email",
            should_be_greater_that_zero: "Should be greater than zero",
        }
    },
    send_invoice_via_email: {
        email_header: "Invoice {{invoiceNo}} from {{companyName}}",
        email_body: "Hello,\n\nPlease find the invoice attached.\n\nThanks,\n{{companyName}}"
    },
    ...currencyTranslations,
}